import React from 'react'
import Form from 'react-bootstrap/Form'
import {
  useAccountGroupings,
  defaultGrouping
} from 'api/hooks/use-account-groupings'

// Which account grouping a surface reports under.
//
// A View always reports under something; a report may decline, so its modal passes
// `inheritLabel` for the "let each dataset's View decide" option — a real third state, not a
// synonym for the default.
//
// Controlled, not self-saving: the change re-buckets every chart, so it belongs behind the
// surface's own Save. Renders nothing when the district keeps a single grouping.
const AccountGroupingSelect = ({
  value,
  onChange,
  disabled = false,
  label = 'Account Grouping',
  controlId = 'viewAccountGrouping',
  ariaLabel = 'Account grouping for this view',
  testId = 'view-grouping-select',
  helpText = "The taxonomy this View's charts, grid and exports roll accounts up under. " +
    'Changing it re-buckets every rollup column.',
  inheritLabel = null
}) => {
  const { data: groupings } = useAccountGroupings({})

  if ((groupings || []).length < 2) return null

  // Without an inherit option, empty resolves to the default server-side — show that rather
  // than a blank. With one, empty is a choice of its own and stays selectable.
  const selected = inheritLabel
    ? value || ''
    : value || defaultGrouping(groupings)?.id || ''

  return (
    <Form.Group controlId={controlId}>
      {label && <Form.Label>{label}</Form.Label>}
      <Form.Select
        aria-label={ariaLabel}
        data-testid={testId}
        value={selected}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      >
        {inheritLabel && <option value="">{inheritLabel}</option>}
        {groupings.map((grouping) => (
          <option key={grouping.id} value={grouping.id}>
            {grouping.name}
          </option>
        ))}
      </Form.Select>
      <Form.Text className="text-muted">{helpText}</Form.Text>
    </Form.Group>
  )
}

export default AccountGroupingSelect
